import { createContext } from "react";

const DF_LO0012Context = createContext();

export { DF_LO0012Context };
